<div id="wrapper">
  <app-navbar></app-navbar>

  <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

  <div class="content-page">
    <div class="content">
      <div class="content-pane">
        <div class="container-fluid">
          <div class="breadcrumb">
            <span class="breadcrumb-item">
              <a href="javascript:void(0)">PayEXAP</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/credit-notes">Credit Notes</a>
            </span>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="pane-header mb-3">
                    <div class="row">
                      <div class="col-md-6">
                        <h4 class="mt-2">Manage Credit Notes</h4>
                      </div>
                      <div class="col-md-6">
                        <div class="dropdown float-end mt-3">
                          <span class="dropdown">
                            <button class="btn btn-invoice dropdown-toggle mr-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">Submit Credit Note</button>
                            <ul class="dropdown-menu">
                              <li>
                                <a class="dropdown-item" routerLink="/purchase-orders"> PO based </a>
                              </li>
                              <li>
                                <a class="dropdown-item" routerLink="/invoices"> Invoice Based </a>
                              </li>
                              <!-- <li>
                                <a class="dropdown-item" routerLink="/submit-ledger"> Ledger Level </a>
                              </li> -->
                            </ul>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="search-pane">
                    <div class="row">
                      <div class="col-md-2 col-sm-4">
                        <label class="d-inline-flex align-items-center mb-3">
                          <select id="show-headers" class="form-select form-select-sm mx-1" [(ngModel)]="filterBy">
                            <option disabled selected hidden>Select</option>
                            <option value="docIdRegex">CN / DN No.</option>
                            <option value="barcodeRegex">Barcode No.</option>
                            <option value="poNoNumberOrString">PO No.</option>
                            <option value="statusRegex">Current Status</option>  
                          </select>
                        </label>
                      </div>
                      <div class="col-md-4 col-sm-8">
                        <div class="input-group flex-nowrap">
                          <ng-container *ngIf="selectedOption">
                            <input
                              type="text"
                              class="form-control highlighted"
                              placeholder="Enter search value"
                              aria-label="search"
                              aria-describedby="addon-wrapping"
                              (keyup)="onSearch($event)"
                            />
                            <span class="input-group-text highlighted" id="addon-wrapping"><i class="ri-search-line"></i></span>
                          </ng-container>
                          <ng-container *ngIf="!selectedOption">
                            <input type="text" class="form-control" placeholder="Search..." aria-label="search" aria-describedby="addon-wrapping" (keyup)="generalSearch($event)" />
                            <span class="input-group-text" id="addon-wrapping"><i class="ri-search-line"></i></span>
                          </ng-container>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="download-pane float-end d-flex align-items-center gap-3">
                          <i
                            class="ri-refresh-line"
                            title="Refresh"
                            (click)="!loading && fetchNotes()"
                            [style.opacity]="loading ? 0.45 : 1"
                            [style.pointer-events]="loading ? 'none' : 'auto'"
                          ></i>
                          <i class="ri-file-download-line" (click)="exportToExcel()"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <div class="loader text-center" *ngIf="loading">
                      <app-loader></app-loader>
                    </div>
                    <ng-container *ngIf="!loading">
                      <div *ngIf="isEmpty" class="text-center py-5">
                        <img src="assets/images/empty-state.png" alt="No-data" />
                        <h1 class="card-title my-2">No Credit/Debit Note Available</h1>
                        <p class="card-text">There is no available data to show yet</p>
                      </div>

                      <ng-container *ngIf="!isEmpty">
                        <table
                          aria-describedby="credit-notes"
                          id="demo-foo-pagination"
                          class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint footable-loaded footable purchase-orders text-nowrap"
                          data-page-size="5"
                        >
                          <thead>
                            <tr>
                              <th scope="col" [appSort]="notes" data-order="desc" data-name="doc_number">
                                CN / DN No. Number
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>

                              <th scope="col" [appSort]="notes" data-order="desc" data-name="barcode">
                                Barcode No.
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>
                              <th scope="col" [appSort]="notes" data-order="desc" data-name="poNo">
                                PO No.
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>

                              <th scope="col" [appSort]="notes" data-order="desc" data-name="doc_amount">
                                Credit Note Amount
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>
                              <th scope="col" [appSort]="notes" data-order="desc" data-name="doc_type">
                                Doc Type
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>
                              <th scope="col" [appSort]="notes" data-order="desc" data-name="po_currency">
                                Currency
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>
                              <th scope="col" [appSort]="notes" data-order="desc" data-name="current_status">
                                Current Status
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let note of notes">
                              <td>
                                <a routerLink="/credit-note-detail/{{ note.barcode }}">{{ note.docNo }}</a>
                              </td>
                              <td>
                                {{ note.barcode }}
                              </td>
                              <td>
                                {{ note.poNo }}
                              </td>
                              <td>
                                {{ note.docAmount }}
                              </td>
                              <td>
                                {{ note.docType }}
                              </td>

                              <td>
                                {{ note.currCode }}
                              </td>

                              <td>
                                <ng-container
                                  *ngIf="
                                    note.statusJsw === 'SUBMITTED' ||
                                    note.statusJsw === 'IN_QUERY' ||
                                    note.statusJsw === 'PENDING_SUBMISSION' ||
                                    note.statusJsw === 'PENDING_SUBMISSION' ||
                                    note.statusJsw === 'PENDING_SHIPPING_APPROVAL' ||
                                    note.statusJsw === 'PENDING_VESON_APPROVAL' ||
                                    note.statusJsw === 'UNUSED' ||
                                    note.statusJsw === 'UNPAID'
                                  "
                                >
                                  <span class="badge text-bg-primary submitted query">{{ note.statusJsw.replaceAll("_", " ") | titlecase }}</span>
                                </ng-container>
                                <span *ngIf="note.statusJsw === 'IN_PROCESSING'" class="badge text-bg-primary processing">{{ note.statusJsw.replaceAll("_", " ") | titlecase }}</span>
                                <span *ngIf="note.statusJsw === 'POSTED' || note.statusJsw === 'POSTED'" class="badge text-bg-primary posted">{{ note.statusJsw | titlecase }}</span>
                                <span *ngIf="note.statusJsw === 'CLEARED'" class="badge text-bg-primary cleared">{{ note.statusJsw | titlecase }}</span>
                                <span *ngIf="note.statusJsw === 'ACCEPTED' || note.statusJsw === 'APPROVED'" class="badge text-bg-primary accepted approved">{{ note.statusJsw | titlecase }}</span>
                                <span *ngIf="note.statusJsw === 'PAID'" class="badge text-bg-primary paid">{{ note.statusJsw | titlecase }}</span>
                                <ng-container *ngIf="note.docType !== 'PO2S - PO2S' && note.statusJsw !== 'REJECTED'">
                                  <i *ngIf="note.status_reason !== ''" class="ri-information-fill" data-toggle="tooltip" data-placement="bottom" title="{{ note.status_reason }}"></i>
                                </ng-container>
                                <ng-container *ngIf="note.statusJsw === 'REJECTED' || note.statusJsw === 'REJECTED'">
                                  <span class="badge text-bg-primary rejected">{{ note.statusJsw | titlecase }}</span>
                                  <span *ngIf="note.statusJsw === 'REJECTED' || note.statusJsw === 'REJECTED'">
                                    <ng-container *ngIf="note.docType === 'PO2S - PO2S' || note.docType === 'PO2S'">
                                      <i *ngIf="note.rejection1" class="ri-information-fill" data-toggle="tooltip" data-placement="bottom" title="{{ note.rejections.rej1.reason }}"></i>
                                      <i *ngIf="note.rejection2" class="ri-information-fill" data-toggle="tooltip" data-placement="bottom" title="{{ note.rejections.rej2.reason }}"></i>

                                      <ng-container *ngIf="note.status_reason !== ''">
                                        <i class="ri-information-fill" data-toggle="tooltip" data-placement="bottom" title="{{ note.status_reason }}"></i>
                                      </ng-container>
                                    </ng-container>
                                  </span>
                                </ng-container>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot></tfoot>
                        </table>
                        <div class="table-footer py-5">
                          <div class="row">
                            <div class="col-sm-5">
                              <label class="d-inline-flex align-items-center mb-3">
                                Show
                                <select id="demo-show-entries" class="form-select form-select-sm mx-1">
                                  <option value="5">10</option>
                                  <option value="10">25</option>
                                  <option value="15">50</option>
                                  <option value="20">100</option>
                                </select>
                                entries
                              </label>
                            </div>
                            <div class="col-sm-7">
                              <div class="text-end">
                                <!-- Showing 1-5 of 15 entries -->
                                <ul class="pagination pagination-split footable-pagination justify-content-end">
                                  <li class="page-item disabled">
                                    <a class="page-link"><i class="ri-arrow-left-s-line"></i></a>
                                  </li>
                                  <li class="page-item active" aria-current="page">
                                    <a class="page-link" href="#">1</a>
                                  </li>

                                  <li class="page-item disabled">
                                    <a class="page-link" href="#"><i class="ri-arrow-right-s-line"></i></a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
